import { render, staticRenderFns } from "./Alchemer_view_reports.vue?vue&type=template&id=d4b2fb22"
import script from "./Alchemer_view_reports.vue?vue&type=script&lang=js"
export * from "./Alchemer_view_reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports